<template>
  <div class="container">
    <!-- 서브상단영역 -->
    <Loading v-show="loading" />
    <Banner
      title=""
      subtitle=""
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <!-- //메뉴 -->
    <div class="width_wrap">
      <div class="body_content">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">회원가입<span></span></h1>
        <!-- //서브 타이틀영역 -->

        <div class="glores-B-join-wrap glores-B-lan-kr">
          <div class="glores-B-join-step">
            <ol>
              <li><span>01 약관동의</span></li>
              <li class="on"><span>02 정보입력</span></li>
              <li><span>03 가입완료</span></li>
            </ol>
          </div>

          <div class="glores-B-join-title">
            <h3 class="join-title">정보입력</h3>
          </div>

          <form name="mem_reg_form" method="post" enctype="multipart/form-data">
            <input type="hidden" name="tmp_name" value="tmp_val" />
            <input type="hidden" name="this_site_mode" value="1" />
            <input type="hidden" name="this_domain" />
            <input type="hidden" name="post_action" />
            <input
              type="hidden"
              name="form_sess_id"
              value="716vsn2hkvktapfcokmmb69lg7"
            />
            <input type="hidden" name="marketing_agree_data" value="" /><input
              type="hidden"
              name="captcha_str_hash"
              value=""
            />
            <h4 class="glores-B-join-form-title">필수 입력 항목</h4>
            <div class="glores-B-join-form glores-B-lan-kr">
              <dl>
                <dt>
                  <label for="id">아이디 <i>*</i></label>
                </dt>
                <dd>
                  <div class="glores-B-value">
                    <div class="reg_memberID">
                      <input
                        type="text"
                        name="id"
                        id="id"
                        maxlength="12"
                        v-model="formData.id"
                        @input="validateId"
                      />
                      <n-button
                        type="button"
                        :loading="isChecking"
                        @click="processExistMember()"
                      >
                        아이디 중복체크
                      </n-button>
                    </div>
                  </div>
                  <p class="glores-B-info" v-if="!errors.id">
                    아이디는 4~12자의 영문, 숫자 조합으로 입력해주세요.
                  </p>
                  <p v-if="errors.id" class="glores-B-error-msg">
                    {{ errors.id }}
                  </p>
                </dd>
              </dl>
              <dl>
                <dt>
                  <label for="pwd">패스워드 <i>*</i></label>
                </dt>
                <dd>
                  <div class="glores-B-value">
                    <div class="reg_password">
                      <input type="hidden" name="mem_link_yn" value="" />
                      <input
                        type="password"
                        name="pwd"
                        id="pwd"
                        size="12"
                        maxlength="16"
                        v-model="formData.password"
                        @input="validatePassword"
                        autocomplete="new-password"
                      />
                      <label for="pwd_re">패스워드 확인</label>
                      <input
                        type="password"
                        name="pwd_re"
                        id="pwd_re"
                        size="12"
                        maxlength="16"
                        v-model="formData.passwordConfirm"
                        @input="validatePasswordConfirm"
                      />
                    </div>
                  </div>
                  <p
                    class="glores-B-info"
                    v-if="!errors.password && !errors.passwordConfirm"
                  >
                    패스워드는 영문+숫자+특수문자를 조합하여 8자 이상
                    입력해주세요.
                  </p>
                  <p v-if="errors.password" class="glores-B-error-msg">
                    {{ errors.password }}
                  </p>
                  <p v-if="errors.passwordConfirm" class="glores-B-error-msg">
                    {{ errors.passwordConfirm }}
                  </p>
                </dd>
              </dl>
              <dl>
                <dt>
                  <label for="name">성명 </label>
                </dt>
                <dd>
                  <div class="glores-B-value">
                    <div class="reg_name">
                      <input
                        type="text"
                        name="name"
                        id="name"
                        size="20"
                        v-model="formData.name"
                        maxlength="20"
                      />
                    </div>
                  </div>
                  <p v-if="errors.name" class="glores-B-error-msg">
                    {{ errors.name }}
                  </p>
                </dd>
              </dl>
              <dl>
                <dt>
                  <label for="email">이메일 <i>*</i></label>
                </dt>
                <dd>
                  <div class="glores-B-value">
                    <div class="reg_email">
                      <input
                        type="text"
                        name="email"
                        id="email"
                        v-model="formData.email"
                        @input="validateEmail"
                      />
                    </div>
                  </div>
                  <p class="glores-B-info" v-if="!errors.email">
                    이메일 주소를 입력하세요.
                  </p>
                  <p v-if="errors.email" class="glores-B-error-msg">
                    {{ errors.email }}
                  </p>
                </dd>
              </dl>
            </div>

            <div class="glores-B-btn-wrap glores-B-m-half">
              <div class="btn-cell">
                <a
                  @click.prevent="goBack"
                  class="glores-B-btn-type1 glores-B-large glores-B-m-full-width"
                  >이전</a
                >
              </div>
              <div class="btn-cell">
                <n-button
                  type="primary"
                  @click="processRegistration"
                  class="glores-B-btn-type1 glores-B-large glores-B-m-full-width glores-B-highlight"
                  :loading="isRegistering"
                  style="--n-height: unset !important"
                >
                  회원가입
                </n-button>
              </div>
              <p
                v-if="errors.general"
                class="glores-B-error-msg glores-B-form-error"
              >
                {{ errors.general }}
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useRouter } from "vue-router";

import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants";
import { useAuth } from "@/composables/useAuth";
import { Member } from "@/model/member";
import { useAlertDialog } from "@/composables/useAlert";
const useAlert = useAlertDialog();
import Loading from "@/components/Loading.vue"; // Loading 컴포넌트 임포트
import * as common from "@/assets/common/common";
const loading = ref(false);
const isChecking = ref(false);
const isRegistering = ref(false);
const { signInWithCustomUser, existMember } = useAuth();
const router = useRouter();

const formData = ref({
  id: "", // 사용자 아이디 (username)
  password: "",
  passwordConfirm: "",
  name: "",
  email: "",
});

const errors = ref({
  id: "",
  password: "",
  passwordConfirm: "",
  name: "",
  email: "",
  general: "", // 폼 전체 또는 API 오류 메시지
});
const isIdCheckedAndAvailable = ref(false);
watch(
  () => formData.value.id,
  (newId, oldId) => {
    if (newId !== oldId) {
      isIdCheckedAndAvailable.value = false;
    }
  }
);
function goBack() {
  router.back();
}

const validateId = () => {
  errors.value.id = ""; // 현재 필드 오류 초기화
  let isValid = true;
  // 아이디 유효성 검사 (4~12자, 영문/숫자)
  const idRegex = /^[a-zA-Z0-9]{4,12}$/;
  if (!formData.value.id) {
    errors.value.id = "아이디를 입력해주세요.";
    isValid = false;
  } else if (!idRegex.test(formData.value.id)) {
    errors.value.id = "아이디는 4~12자의 영문 또는 숫자만 사용 가능합니다.";
    isValid = false;
  }
  return isValid;
};

const validatePassword = () => {
  errors.value.password = ""; // 현재 필드 오류 초기화
  let isValid = true;
  // 패스워드 유효성 검사 (8~16자, 영문, 숫자, 특수문자 조합)
  const passwordRegex =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,16}$/;
  if (!formData.value.password) {
    errors.value.password = "패스워드를 입력해주세요.";
    isValid = false;
  } else if (!passwordRegex.test(formData.value.password)) {
    errors.value.password =
      "패스워드는 8~16자의 영문, 숫자, 특수문자를 모두 포함해야 합니다.";
    isValid = false;
  }
  // 비밀번호가 변경되면 비밀번호 확인 필드도 다시 검증
  if (formData.value.passwordConfirm) {
    validatePasswordConfirm();
  }
  return isValid;
};

const validatePasswordConfirm = () => {
  errors.value.passwordConfirm = ""; // 현재 필드 오류 초기화
  let isValid = true;
  // 패스워드 확인
  if (!formData.value.passwordConfirm) {
    errors.value.passwordConfirm = "패스워드 확인을 입력해주세요.";
    isValid = false;
  } else if (formData.value.password !== formData.value.passwordConfirm) {
    errors.value.passwordConfirm = "패스워드가 일치하지 않습니다.";
    isValid = false;
  }
  return isValid;
};

const validateEmail = () => {
  errors.value.email = ""; // 현재 필드 오류 초기화
  let isValid = true;
  // 이메일 유효성 검사
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!formData.value.email) {
    errors.value.email = "이메일을 입력해주세요.";
    isValid = false;
  } else if (!emailRegex.test(formData.value.email)) {
    errors.value.email = "올바른 이메일 형식이 아닙니다.";
    isValid = false;
  }
  return isValid;
};

function validateFormBeforeSubmit(): boolean {
  // 모든 개별 유효성 검사를 실행하여 errors 객체를 최신 상태로 업데이트
  const isIdValid = validateId();
  const isPasswordValid = validatePassword();
  const isPasswordConfirmValid = validatePasswordConfirm();
  const isEmailValid = validateEmail();

  // 모든 필드가 유효한지 확인
  return isIdValid && isPasswordValid && isPasswordConfirmValid && isEmailValid;
}

async function join() {
  isRegistering.value = true;
  errors.value.general = "";
  try {
    const memberData: Member = {
      uid: formData.value.id,
      password: formData.value.password,
      name: formData.value.name == "" ? undefined : formData.value.name,
      email: formData.value.email,
      type: "custom",
    };
    let error = await signInWithCustomUser(memberData);
    if (error != null) {
      console.error("회원가입 실패:", error);
      errors.value.general = `회원가입 중 오류가 발생했습니다. (${
        error.message || "알 수 없는 오류"
      })`;
      isRegistering.value = false;
      await useAlert(errors.value.general);
    } else {
      router.push(
        `${USER_ROUTES.Join.Success.Path.replace(":id", formData.value.id)}`
      );
    }
  } catch (error: any) {
    console.error("회원가입 실패:", error);
    errors.value.general = `회원가입 중 오류가 발생했습니다. (${
      error.message || "알 수 없는 오류"
    })`;
    isRegistering.value = false;
    await useAlert(errors.value.general);
  } finally {
    isRegistering.value = false;
  }
}

async function processRegistration() {
  errors.value.general = ""; // 이전 일반 오류 메시지 초기화
  if (!validateFormBeforeSubmit()) {
    return;
  }
  if (!isIdCheckedAndAvailable.value) {
    errors.value.general = "아이디 중복 확인을 완료해주세요.";
    if (!errors.value.id) {
      errors.value.id = "아이디 중복 확인이 필요합니다.";
    }
    await useAlert(
      "아이디 중복 확인을 해주세요. 사용 가능한 아이디인지 확인 후 다시 시도해주세요."
    );

    return;
  }
  await join();
}

async function processExistMember() {
  errors.value.id = "";
  errors.value.general = "";
  isIdCheckedAndAvailable.value = false;

  if (!validateId()) {
    return;
  }
  isChecking.value = true;
  try {
    const memberData: Member = {
      uid: formData.value.id,
      type: "custom",
    };
    let result: any = await existMember(memberData);
    if (common.evalFunctionResult(result)) {
      if (result.data.data == false) {
        errors.value.id = ""; // 성공 시 이전 ID 오류 메시지 제거
        isIdCheckedAndAvailable.value = true;
        await useAlert("사용 가능한 아이디입니다.");
      } else {
        console.error("아이디 중복!");
        isChecking.value = false;
        errors.value.id = "이미 사용 중이거나 사용할 수 없는 아이디입니다.";
        isIdCheckedAndAvailable.value = false;
        await useAlert(errors.value.id);
      }
    } else {
      isIdCheckedAndAvailable.value = false;
      let error: any = common.getResultError(result);
      console.error("아이디 중복체크 실패:", error);
      isChecking.value = false;
      errors.value.general = `아이디 중복체크 중 오류가 발생했습니다. (${
        error.message || "알 수 없는 오류"
      })`;
      await useAlert(errors.value.general);
    }
  } catch (error: any) {
    isIdCheckedAndAvailable.value = false;

    console.error("아이디 중복체크 실패:", error);
    isChecking.value = false;
    errors.value.general = `아이디 중복체크 중 오류가 발생했습니다. (${
      error.message || "알 수 없는 오류"
    })`;
    await useAlert(errors.value.general);
  } finally {
    isChecking.value = false;
  }
}
</script>

<style scoped>
.glores-B-error-msg {
  color: red;
  font-size: 0.9em;
  margin-top: 5px;
}
.glores-B-form-error {
  width: 100%;
  text-align: center;
  margin-top: 15px;
}

/*
  "회원가입" 버튼 로딩 아이콘 위치 정상화를 위한 스타일
  다른 glores-B-* 스타일에 의해 아이콘 위치가 변경되는 것을 방지합니다.
*/
.glores-B-btn-wrap
  .btn-cell
  .n-button.glores-B-btn-type1.glores-B-large.glores-B-highlight.n-button--loading {
  /* 버튼 자체가 Naive UI 기본 flex 동작을 유지하도록 강제 */
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important; /* 아이콘+텍스트 그룹을 중앙 정렬 */
  text-align: initial !important; /* text-align으로 인한 문제 방지 */
}

.glores-B-btn-wrap
  .btn-cell
  .n-button.glores-B-btn-type1.glores-B-large.glores-B-highlight.n-button--loading
  .n-button__content {
  /* 텍스트 내용이 실제로 보이도록 강제합니다. */
  display: inline !important; /* span의 기본값, flex 아이템으로 자연스럽게 동작 */
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  opacity: 1 !important;
  overflow: visible !important;
  /* 숨김 처리될 수 있는 다른 속성 초기화 */
  font-size: inherit !important; /* glores-B-* 스타일에 의해 font-size: 0 되는 것 방지 */
  line-height: inherit !important; /* glores-B-* 스타일에 의해 line-height: 0 되는 것 방지 */
  color: inherit !important; /* glores-B-* 스타일에 의해 color: transparent 되는 것 방지 */
  text-indent: 0 !important;
  position: static !important;
  margin: 0 !important; /* 모든 margin 리셋 */
  padding: 0 !important; /* 모든 padding 리셋 */
  border: none !important; /* 모든 border 리셋 */
  order: 1 !important; /* 아이콘 뒤에 오도록 순서 강제 */
}

.glores-B-btn-wrap
  .btn-cell
  .n-button.glores-B-btn-type1.glores-B-large.glores-B-highlight.n-button--loading
  .n-button__icon {
  /* 아이콘이 정상적으로 표시되도록 합니다. */
  display: inline-flex !important; /* 스피너를 내부에서 중앙 정렬하기 위해 flex 유지 */
  align-items: center !important; /* 스피너 수직 중앙 정렬 */
  justify-content: center !important; /* 스피너 수평 중앙 정렬 */
  /* 아이콘과 텍스트 사이에 간격을 줍니다. (Naive UI 기본값과 유사하게) */
  margin-right: 6px !important;
  margin-left: 0 !important;
  flex-shrink: 0 !important; /* 아이콘이 줄어들지 않도록 함 */
  position: static !important; /* position이 absolute로 변경되는 것 방지 */
  order: 0 !important; /* 텍스트 앞에 오도록 순서 강제 */
  font-size: inherit !important; /* 버튼의 폰트 크기를 상속받아 'em' 단위의 기준이 되도록 함 */
  height: 1em !important; /* 아이콘 컨테이너의 높이를 버튼 폰트 크기의 1배로 고정 */
  line-height: 1em !important; /* 아이콘 컨테이너 자체의 line-height를 높이와 일치시켜 추가 공간 방지 */
}
</style>
